import { generateRandomWinningTimes } from '@/lib/raspadinha-campaigns/generate-random-winning-times'
import type { ApiRouletteSlot } from './types'

export function generateApiRouletteSlots(
  slots: ApiRouletteSlot[],
  input: {
    from: string
    until: string
    start: string
    end: string
    count: number
    slice: string
  }
): ApiRouletteSlot[] {
  if (
    !input.slice ||
    !/^\d{4}-\d{2}-\d{2}$/.test(input.from) ||
    !/^\d{4}-\d{2}-\d{2}$/.test(input.until) ||
    input.from > input.until
  )
    throw new Error('Informe o período e a fatia premiada.')
  const result = [...slots]
  const cursor = new Date(`${input.from}T12:00:00Z`)
  const end = new Date(`${input.until}T12:00:00Z`)
  if (
    Number.isNaN(cursor.getTime()) ||
    Number.isNaN(end.getTime()) ||
    (end.getTime() - cursor.getTime()) / 86400000 > 365
  )
    throw new Error('Use um período de até 366 dias.')
  if (
    cursor.toISOString().slice(0, 10) !== input.from ||
    end.toISOString().slice(0, 10) !== input.until
  )
    throw new Error('Informe datas válidas.')
  if (!Number.isInteger(input.count))
    throw new Error('Informe uma quantidade inteira de horários.')
  while (cursor <= end) {
    const date = cursor.toISOString().slice(0, 10)
    const generated = generateRandomWinningTimes({
      winnerCount: input.count,
      startTime: input.start,
      endTime: input.end,
      occupiedTimes: result.filter((slot) => slot.date === date).map((slot) => slot.time),
    })
    if (!generated.ok) throw new Error(`${date}: ${generated.error}`)
    for (const time of generated.times)
      result.push({
        id: crypto.randomUUID(),
        date,
        time,
        winning_slice_id: input.slice,
        is_active: true,
      })
    if (result.length > 5000)
      throw new Error('O limite é de 5.000 horários por campanha.')
    cursor.setUTCDate(cursor.getUTCDate() + 1)
  }
  return result.sort((a, b) => `${a.date} ${a.time}`.localeCompare(`${b.date} ${b.time}`))
}
